import { Button } from "PFComponents/button";
import SidePanel from "PFComponents/side_panel/side_panel";
import { Typography } from "PFComponents/typography";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import css from "./search_like_a_pro.module.scss";

export const SearchLikeAPro = () => {
  const { t } = useTranslation("search");
  const [showPanel, setShowPanel] = useState(false);

  return (
    <>
      <Button
        icon="info"
        text={t("searchLikeAPro.searchLikeAPro")}
        kind="tertiary"
        className={css.root}
        onClick={() => setShowPanel(true)}
      />
      <SidePanel show={showPanel} onClose={() => setShowPanel(false)} title={t("searchLikeAPro.panelHeader")}>
        <Typography variant="bodyRegular" className={css.panelContent}>
          {t("searchLikeAPro.descriptionFirst")}
        </Typography>
        <Typography variant="bodyRegular" className={css.panelContent}>
          {t("searchLikeAPro.descriptionSecond")}
        </Typography>
        <Typography variant="bodyRegular" className={css.panelContent}>
          {t("searchLikeAPro.descriptionThird")}
        </Typography>
      </SidePanel>
    </>
  );
};
